"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
var React = require("react");
var DropdownItem = function (props) {
    return (React.createElement("li", { "data-index": props.dataIndex, value: props.value }, props.label));
};
exports.DropdownItem = DropdownItem;
//# sourceMappingURL=DropdownItem.js.map